import { z } from 'zod'

export const requireOTPSchema = z.object({
  id: z.string(),
  createdAt: z.string(),
  hoursSinceCreation: z.number(),
  requireOtp: z.boolean()
})
